import React, { createContext, useReducer } from 'react';

const initialState = {
  scrollEl: null,
  scrollProgress: 0,
  handleContent: '2019'
};

// Context
const State = createContext(initialState);
const Dispatch = createContext();

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case 'setScrollEl':
      return {
        ...state,
        scrollEl: action.scrollEl,
      };
    case 'setScrollProgress':
      return {
        ...state,
        scrollProgress: action.scrollProgress,
      };
    case 'setHandleContent':
      return {
        ...state,
        handleContent: action.value,
      };
    default:
      return state;
  }
};

// Provider
const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <State.Provider value={state}>
      <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>
  );
};

export const ScrollPosition = {
  State,
  Dispatch,
  Provider,
};
